import axios from "axios";
import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { Category } from "../../../@types/Category";
import axiosInstance from "../../../utils/axiosConfig";

export const findCategory = createAsyncThunk(
  "utils/findCategory",
  async (props, { rejectWithValue, getState }) => {
    try {

      const { data } = await axiosInstance.get(`${api.baseURL}category?limit=1000`);

      return data as Category[];
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
